// @ts-nocheck
import getImageSize from "@toolkit/Framework/Common/Utilities/getImageSize";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const fallbackFont = "Arial, Helvetica, sans-serif";

const design: Styleguide["design"] = {
    category: {
        image: {
            small: getImageSize(768),
        },
    },
    product: {
        image: {
            small: getImageSize(210),
            medium: getImageSize(768),
            large: getImageSize(1200),
        },
    },
    typography: {
        fontFamily: {
            title: `'Roboto', ${fallbackFont}`,
            base: `'Roboto', ${fallbackFont}`,
        },
        size: {
            larger: pxToRem(20),
            big: pxToRem(26),
        },
    },
    radius: {
        main: "4px",
    },
    myAccount: {
        pagination: {
            spacing: "2rem",
        },
    },
};

export default design;
